<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="1">
							<v-text-field clearable dense label="昵称" outlined v-model="query.nickName">
							</v-text-field>
						</v-col>
						<v-col cols="1">
							<v-text-field clearable dense label="手机号" outlined v-model="query.mobile">
							</v-text-field>
						</v-col>
						<v-col cols="1">
							<v-select label="状态" :items="query.statusItems" v-model="query.status" item-text="name" item-value="id" dense outlined></v-select>
						</v-col>
						
						<v-col cols="7">
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
						<v-col cols="12">

							<v-btn small @click="showAddDialog" color="info">添加家长账号</v-btn>
						</v-col>
					</v-row>
				</template>
				
				<template v-slot:item.status="{item}">
					<v-chip small :color="item.status==='1'?'success':'error'" class="mr-3">
						{{ item.status==='1'?'正常':'冻结' }}
					</v-chip>
				</template>
				<template v-slot:item.shopStudentList="{item}">
					<v-chip v-for="(item,index) in item.shopStudentList" :key="index" small color="info" class="mr-3">
						{{ item.studentName }}
					</v-chip>
				</template>
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showUpdate(item)" color="primary" x-small>修改</v-btn>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		
		<!-- 添加 dialog -->
		<v-dialog title="添加家长账号" v-model="add.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>添加家长账号</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="昵称" v-model="add.user.nickName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="手机号" placeholder="登录系统的手机号" v-model="add.user.mobile" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="登录密码" v-model="add.user.password" dense outlined></v-text-field>		
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12">
							<span style="color:orange">关联学员</span>
						</v-col>
					</v-row>
					<v-row dense v-for="(item,index) in add.shopStudentRows" :key="index">
						<v-col cols="5">
							<v-select v-model="item.shopId" :items="selectShopList" label="选择校区" 
								item-text="shopName" item-value="id" outlined dense @change="rowShopChanged"></v-select>
						</v-col>
						<v-col cols="5">
							<v-select :ref="'student'+item.shopId" v-model="item.studentId" :items="item.selectStudentList" label="学员"
								item-text="studentName" item-value="id" outlined dense></v-select>
						</v-col>
						<v-col cols="2">
							<v-btn class="mt-2" x-small v-if="index ===0" color="primary" @click="addRow">再加一个</v-btn>
							<v-btn class="mt-2" x-small v-if="index > 0" color="error" @click="deleteRow(index)">删除</v-btn>
						</v-col>
					</v-row>
				
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddUser" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 修改 dialog -->
		<v-dialog title="修改家长账号" v-model="update.dialog" max-width="600">
			<v-card>
				<v-card-title>修改家长账号</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="6">
							<v-text-field label="昵称" v-model="update.user.nickName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="手机号" placeholder="登录系统的手机号" v-model="update.user.mobile" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select label="状态" :items="update.statusItems" v-model="update.user.status" item-text="name" item-value="id" dense outlined></v-select>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12">
							<span style="color:orange">已关联学员</span>
						</v-col>
					</v-row>
					<v-row dense v-for="(item,index) in update.shopStudentList" :key="index">
						<v-col cols="5">
							{{item.studentNo}}
						</v-col>
						<v-col cols="5">
							{{item.studentName}}
						</v-col>
						<v-col cols="2">
							<v-btn class="mt-2" x-small color="error" @click="update.shopStudentList.splice(index,1)">删除</v-btn>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12">
							<span style="color:orange" class="mr-3">添加新关联学员</span>
							<v-btn class="mt-0" x-small color="primary" @click="addRowForUpdate">添加</v-btn>
						</v-col>
						
					</v-row>
					<v-row dense v-for="(item,index) in update.shopStudentRows" :key="index">
						<v-col cols="5">
							<v-select v-model="item.shopId" :items="selectShopList" label="选择校区" 
								item-text="shopName" item-value="id" outlined dense @change="updateRowShopChanged"></v-select>
						</v-col>
						<v-col cols="5">
							<v-select :ref="'student'+item.shopId" v-model="item.studentId" :items="item.selectStudentList" label="学员"
								item-text="studentName" item-value="id" outlined dense></v-select>
						</v-col>
						<v-col cols="2">
							<v-btn class="mt-2" x-small color="error" @click="update.shopStudentRows.splice(index,1)">删除</v-btn>
						</v-col>
					</v-row>
				
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdate" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	</v-card>
</template>

<script>

	import global from '../../../config/global'
	import storage from "../../../config/storage"

	import md5 from "js-md5"
	export default {
		name: "app-user-list",
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '家长账号管理',
						disabled: true
					},
				],
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '昵称',
							value: 'nickName',
							sortable: false
						},
						{
							text: '手机号',
							value: 'mobile',
							sortable: false
						},
						{
							text: '关联学员',
							value: 'shopStudentList',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList: [], // 校区
				query: {
					loading: false,
					page: 1,
					size: 20,
					nickName: "",
					shopId:"",
					status:"1",
					statusItems:[
						{id:"",name:"全部"},
						{id:"1",name:"正常"},
						{id:"0",name:"冻结"},
					]
				},
				add: {
					dialog: false,
					user: {
						nickName: "",
						mobile: "",
						password: "",
						studentIdList: [],
					},
					shopStudentRows:[
						{shopId:"",studentId:"",selectStudentList:[]},
					],
				},
				update: {
					dialog: false,
					user: {
						id:"",
						nickName: "",
						mobile: "",
						studentIdList:[],
						status:"",
					},
					shopStudentList: [], // 已有的学员
					shopStudentRows:[],  // 新添加的学员
					statusItems:[
						{id:"1",name:"正常"},
						{id:"0",name:"冻结"},
					]
				},
			}
		},
		created() {
			// 加载校区列表
			this.getShopListForSelect();
			
			this.getTableDataList();

		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			addRow(){
				if(this.add.shopStudentRows.length >=5){
					this.$noty.error("最多5行");
					return
				}
				this.add.shopStudentRows.push({shopId:"",studentId:"",selectStudentList:[]});
			},
			rowShopChanged(shopId) {
				// 更新这行的学生
				this.getStudentsForSelect(shopId);
			},
			deleteRow(index){
				if (index<1){
					this.$noty.error("最少要关联1个学生");
					return
				}
				this.add.shopStudentRows.splice(index,1);
			},
			addRowForUpdate(){
				// 修改dialog 增加一行
				if(this.update.shopStudentRows.length >=5){
					this.$noty.error("最多5行");
					return
				}
				this.update.shopStudentRows.push({shopId:"",studentId:"",selectStudentList:[]});
			},
			updateRowShopChanged(shopId) {
				// 更新这行的学生
				this.getUpdateStudentsForSelect(shopId);
			},
			showAddDialog() {
		
				// 清空历史数据
				this.add.user.studentIdList = [];
				this.add.user.nickName = "";
				this.add.user.mobile = "";
				this.add.user.password = "";
				this.add.shopStudentRows =[{shopId:"",studentId:"",selectStudentList:[]}];
						
				this.add.dialog = true;

			},
			showUpdate(item){
				this.update.user.id = item.id;
				this.update.user.nickName = item.nickName;
				this.update.user.mobile = item.mobile;
				this.update.user.studentIdList = [];
				this.update.user.status = item.status;
				
				this.update.shopStudentList = item.shopStudentList; // 已关联学员
				this.update.shopStudentRows = []; // 新加的关联学员
				
				this.update.dialog = true;
			},
			submitUpdate(){
				if (!this.update.user.nickName) {
					this.$noty.error('昵称不能为空');
					return
				}
				
				if (!this.update.user.mobile) {
					this.$noty.error('手机号不能为空');
					return
				}
	
				// 处理关联学员
				this.update.user.studentIdList = [];
				if(this.update.shopStudentList){
					this.update.shopStudentList.forEach((item,index)=>{
						if (item.studentId){
							this.update.user.studentIdList.push(item.studentId);
						}
					})
				}
				if(this.update.shopStudentRows){
					
					this.update.shopStudentRows.forEach((item,index)=>{
						if (item.studentId){
							this.update.user.studentIdList.push(item.studentId);
						}
					})
				}
				
				console.log("studentIDS:",this.update.user.studentIdList);
				
				if(this.update.user.studentIdList.length < 1){
					this.$noty.error('至少关联1个学员');
					return
				}
				
				
				// api
				const that = this;
				let url = `/sys/app/user/update`;
							
				// parameters
				
				const updateData = {
					...this.update.user
				}
				
				console.log(updateData);
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
						
				
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/sys/app/user/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if (this.query.nickName) {
					url += "&nickName=" + this.query.nickName;
				}
				if (this.query.mobile) {
					url += "&mobile=" + this.query.mobile;
				}


				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			submitAddUser() {

				if (!this.add.user.nickName) {
					this.$noty.error('昵称不能为空');
					return
				}
				
				if (!this.add.user.mobile) {
					this.$noty.error('手机号不能为空');
					return
				}
				if (!this.add.user.password) {
					this.$noty.error('请输入登录密码');
					return
				}
				
				if(!this.add.shopStudentRows){
					this.$noty.error('请关联学生');
					return
				}
				if(this.add.shopStudentRows.length == 0){
					this.$noty.error('请关联学生');
					return
				}
				//把选择的学生加到列表
				this.add.user.studentIdList = [];
				this.add.shopStudentRows.forEach((item,index)=>{
					if(item.studentId){
						this.add.user.studentIdList.push(item.studentId);
					}
				})
				
				console.log("studentIDS:",this.add.user.studentIdList);
			
				if (this.add.user.studentIdList.length == 0) {
					this.$noty.error('请选择学员');
					return
				}

				// api
				const that = this;
				let url = `/sys/app/user/create`;
				let postData = {
					...this.add.user
				};

				postData.password = md5(postData.password);
				
				console.log("===post data ====");
				console.log(postData);
				console.log("===post data ====");
		
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			getStudentsForSelect(shopId){
				
				const that = this;
				let url = `/edu/shop/student/list/${shopId}`;
				
				console.log(url);
			
				this.axios.get(url).then(response => {
					
					console.log(response.data["data"]);
					if (response.data["code"] === 200) {
						
						// 返回的数据
						const studentList = response.data["data"] ? response.data["data"] : [];
						// 构造新数据对象
						let newStuList = [];
						if (studentList && studentList.length > 0){
							
							studentList.forEach((item,index)=>{
								newStuList.push({id:parseInt(item.id),studentName:item.studentName})
							});
						}
						
						// 赋值新对象
						that.selectStudentList = newStuList;;
						
						that.add.shopStudentRows.forEach((item,index)=>{
							if (item.shopId == shopId){
								item.selectStudentList = newStuList;
							}
						})
						
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;

				this.axios.get(url).then(response => {
					
					console.log(response);

					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getUpdateStudentsForSelect(shopId){
				
				const that = this;
				let url = `/edu/shop/student/list/${shopId}`;
				
				console.log(url);
			
				this.axios.get(url).then(response => {
					
					console.log(response.data["data"]);
					if (response.data["code"] === 200) {
						
						// 返回的数据
						const studentList = response.data["data"] ? response.data["data"] : [];
						// 构造新数据对象
						let newStuList = [];
						if (studentList && studentList.length > 0){
							
							studentList.forEach((item,index)=>{
								newStuList.push({id:parseInt(item.id),studentName:item.studentName})
							});
						}
						
						// 赋值新对象
						that.selectStudentList = newStuList;;
						
						that.update.shopStudentRows.forEach((item,index)=>{
							if (item.shopId == shopId){
								item.selectStudentList = newStuList;
							}
						})
						
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style>
</style>
